<div class="wrapper">

  <campaign-header
  [step]="step"
  [campaign]="campaign"
  (saveAndExit)="saveAndExit($event)"></campaign-header>
  <campaign-steps
  [step]="step"
  [campaign]="campaign"></campaign-steps>
  <campaign-status
  [step]="step"></campaign-status>

  <p-messages *ngIf="missingNameErrors.length > 0" [(value)]="missingNameErrors"></p-messages>
  <p-messages *ngIf="budgetWarnings.length > 0" [(value)]="budgetWarnings"></p-messages>

  <div class="campaign-fase">
    <campaign-step-1 *ngIf="step == 1" [campaign]="campaign"></campaign-step-1>
    <campaign-step-2
    *ngIf="step == 2"
    [savedPriorities]="savedPriorities"
    [campaign]="campaign"
    (prioritiesChanged)="prioritiesHandler($event)"></campaign-step-2>
    <campaign-step-3
    *ngIf="step == 3"
    [campaign]="campaign"
    (campaignNameError)="campaignNameError($event)"
    (budgetChanged)="budgetChangeHandler($event)"
    (discountsChanged)="discountsChangedHandler($event)"></campaign-step-3>
    <campaign-step-4
    *ngIf="step == 4"
    [campaign]="campaign"
    [targetedStores]="targetedStores"
    (savedSelectedCategories)="saveSelectedCategories($event)"
    (savedSelectedProductCouponsF)="saveSelectedProductCouponsF($event)"
    (savedSelectedProductCouponsNF)="saveSelectedProductCouponsNF($event)"
    [returnedSavedCategories]="returnedSavedCategories"
    [returnedSavedProductCouponsF]="returnedSavedProductCouponsF"
    [returnedSavedProductCouponsNF]="returnedSavedProductCouponsNF"></campaign-step-4>
    <campaign-step-5
    *ngIf="step == 5"
    [campaign]="campaign"
    [savedCategories]="savedCategories"
    [savedProductCouponsF]="savedProductCouponsF"
    [savedProductCouponsNF]="savedProductCouponsNF"
    (returnedSavedCategories)="returnSavedCategories($event)"
    (returnedSavedProductCouponsF)="returnSavedProductCouponsF($event)"
    (returnedSavedProductCouponsNF)="returnSavedProductCouponsNF($event)"
    (availableTargeting)="availableTargetingHandler($event)"></campaign-step-5>
  </div>

  <div class="ui-g-6" style="display: flex; justify-content: center; margin: 30px 0 15px 0;">
    <app-go-back-button
    *ngIf="step != 1 && step != 4"
    (goBackBtnClicked)="prevStep()"
    ></app-go-back-button>
  </div>
  <div class="ui-g-6 next-btns-container" style="display: flex; justify-content: center; margin: 30px 0 15px 0;">
    <button
    pButton
    type="button"
    class="nextstep"
    style="width: 178px !important; height: 47px; display: flex; align-items: center; justify-content: center;"
    [disabled]="nextDisabled"
    (click)="nextStep()"
    *ngIf="step < 5">
      <span style="margin-right: 10px; font-size: 18px; font-weight: 600;">Next</span>
      <i class="fa fa-chevron-right" style="font-size: 16px;"></i>
    </button>
    <button
      pButton
      [disabled]="!availableTargeting"
      type="button"
      class="nextstep"
      style="height: 47px; display: flex; align-items: center; justify-content: center;"
      (click)="startTargeting()"
      *ngIf="step == 5">
      <span style="margin-right: 10px; font-size: 18px; font-weight: 600;">{{ 'campaign.runTargeting' | translate }}</span>
      <i class="fa fa-chevron-right" style="font-size: 16px;"></i>
    </button>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/new-campaign.html